import './App.css';
import { BrowserRouter, Routes, Route } from "react-router";
import { useEffect,useState,useMemo  } from 'react';
import { Container } from '@mui/material';

import { Fragment } from 'react';
import { Stack } from '@mui/material';
import { Box } from '@mui/material';
import { Grid2 } from '@mui/material';
import { dueesurvey } from './duee-survey';
import { Button,Chip } from '@mui/material';
import { isMobileOnly} from 'react-device-detect';
import { IsMobile } from 'survey-core';
import CustomMySurvey from './customMySurvey';
import { Keyboard } from '@mui/icons-material';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

function App(){
    const [notified, setNotified] = useState(false);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    
    const infos = ()=> console.log("this is a basic quiz, more info to ENEA site. Survey version 0.3 - 2025, February 17");

    
    useEffect(()=>{
        if(IsMobile){
            infos();
            console.log("mobile view");
        }else{
            infos();
            console.log("no mobile view");
        }
    },[]);

    
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    
    //useEffect(()=>{
    //    console.log(windowDimensions.width);
    //},[windowDimensions]);

    const biglogo = useMemo(()=>{
        if(windowDimensions.width<415){
            return "./ENEA_solo_logo.png";
        } else {
            return "./ENEA_orizz_positivo.png";
        }
    },[windowDimensions]);

    // TODO matomo embed 
    /*useEffect(() => {
            var _mtm = window._mtm = window._mtm || [];
            _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src='https://neuron4web.palermo.enea.it/js/}'; s.parentNode.insertBefore(g,s);
    }, [])*/
    // TODO stars
    /*<div className="star" style={{left:'54%',fontSize:44}}/>
        <div className="star" style={{left:'61%',fontSize:24}}/>
        <div className="star" style={{left:'39%',fontSize:32}}/>
    */

    return(
        <BrowserRouter>
            <Routes>
                <Route path="/sprecotest" element={
                    <Container>
                    {!isMobileOnly && (<Box component="section" sx={{ p: 4, paddingRight:0,marginLeft:'-300px',width:'300vw', backgroundColor:' #0060e6' }}/>)}
                    {isMobileOnly && (<Box component="section" sx={{ p: 4, paddingRight:0,marginLeft:'-30px',width:'97vw', backgroundColor:' #0060e6' }}/>)}    
                    <Grid2 container rowSpacing={0}>      
                        <Grid2 sx={{width:'90'}} item size={12}>
                            
                            {isMobileOnly && (<Fragment>
                            <div role="heading" aria-level="1" style={{textAlign:'center',marginTop:'-17px'}}>
                                <img alt="ENEA, Agenzia nazionale per le nuove teconologie, l'energia e lo sviluppo economico sostenibile" title="ENEA" style={{marginLeft:-20,marginTop:-50}} height={48} src={biglogo}/>
                                <img alt="Mi illumino di meno" title="Mi illumino di meno" style={{marginLeft:5,marginTop:-50}} width={59} height={48} src={"./mm.png"}/>
                                <img alt="Italia in classe A" title="Italia in classe A" style={{marginLeft:4,marginTop:-50}} width={84} height={48} src={"./ItaliaInClasseA_compatto.png"}/>
                            </div>
                            </Fragment>)}
                            {!isMobileOnly && (<Fragment>
                            <div role="heading" aria-level="1" style={{textAlign:'start',marginTop:'-17px'}}>
                                <img alt="ENEA, Agenzia nazionale per le nuove teconologie, l'energia e lo sviluppo economico sostenibile" title="ENEA" style={{marginLeft:0,marginTop:-50}} height={50} src={"./ENEA_orizz_positivo.png"}/>
                                <img alt="Mi illumino di meno" title="Mi illumino di meno" style={{marginTop:-50}} width={62} height={50} src={"./mm.png"}/>
                                <img alt="Italia in classe A" title="Italia in classe A" style={{marginTop:-50}} width={88} height={50} src={"./ItaliaInClasseA_compatto.png"}/>
                            </div>
                            </Fragment>)}
                        </Grid2>
                        {notified===true && (
                            <Fragment>
                                <Grid2 item  role="main" rowSpacing={0} size={12}>
                                    <CustomMySurvey surveymodel={dueesurvey}/>
                                </Grid2>
                            </Fragment>)} 
                        {notified===false && (
                            <Fragment>
                            <Grid2 item size={12}>
                                <Stack role="img">
                                    <img className={'title-img-cx'} style={{marginTop:'0'}}  alt="Fashion sprecotest" src="./images/img-cx-titolo.png"/>
                                    <img className={'title-img-dx'} style={{marginLeft:'4%',marginTop:'-43%'}}  alt="Fashion sprecotest line arts" src="./images/img-dx-titolo.png"/>
                                </Stack>
                            </Grid2>
                            <Grid2 item size={12}>            
                                    <div className='description'  role="main" style={{marginTop:'-1%',textAlign:'center'}}>
                                        <h2>Quanta energia consuma il tuo guardaroba?</h2>
                                        <p>Scopri quanto spreco energetico c’è nel tuo modo di vestire!</p>
                                        <p>Sei un Green Shopper o un Energy Waster?</p> 
                                        <p>Rispondi a queste <strong>10</strong> domande e scopri il tuo impatto sul pianeta.</p>
                                        <p>Ogni risposta ha un punteggio che determinerà il tuo livello finale!</p>
                                        <Button accessKey='n' sx={{marginLeft:'0',bgcolor:'#0060e6',fontFamily:'Barlow'}} onClick={()=>setNotified(true)} variant="contained">Iniziamo!</Button>
                                        <p><Chip icon={<Keyboard/>} size="small" label="shift+alt+n per confermare e tasti a, b o c per selezionare le risposte"/></p>
                                    </div>                                                                   
                            </Grid2>
                            </Fragment>)}
                        </Grid2> 
                    </Container>
                }/>        
            </Routes>
        </BrowserRouter>
       
    );
};


export default App;